<template>
  <sScrollbar
    tag="div"
    :view-class="`${prefixClass}-time-column__list`"
    :wrap-class="`${prefixClass}-time-column__wrap`">
    <div
      v-for="item in list"
      :key="item.value"
      :class="[`${prefixClass}-time-option`, getClasses(item.value)]"
      @click="handleSelect(item.value)">
      {{ item.text }}
    </div>
  </sScrollbar>
</template>

<script>
import { format } from 'toolkit/utils/date'
import sScrollbar from 'toolkit/components/scrollbar'
import { getScrollParent } from 'toolkit/utils/date-format-parse/util.js'

import { getLocale } from '../locale'

function parseOption(time = '') {
  const values = time.split(':')
  if (values.length >= 2) {
    const hours = parseInt(values[0], 10)
    const minutes = parseInt(values[1], 10)
    return {
      hours,
      minutes,
    }
  }
  return null
}

const scrollTo = (element, to) => {
  if (element) {
    element.scrollTop = to
  }
}

export default {
  name: 'sDateListOptions',
  components: { sScrollbar },
  inject: {
    getLocale: {
      default: () => getLocale,
    },
    prefixClass: {
      default: 's-datepicker',
    },
  },
  props: {
    date: Date,
    options: {
      type: [Object, Function],
      default() {
        return []
      },
    },
    format: {
      type: String,
      default: 'HH:mm:ss',
    },
    getClasses: {
      type: Function,
      default: () => [],
    },
  },
  computed: {
    list() {
      const result = []
      const { options } = this

      if (typeof options === 'function') {
        return options() || []
      }

      const start = parseOption(options.start)
      const end = parseOption(options.end)
      const step = parseOption(options.step)
      const fmt = options.format || this.format

      if (start && end && step) {
        const startMinutes = start.minutes + start.hours * 60
        const endMinutes = end.minutes + end.hours * 60
        const stepMinutes = step.minutes + step.hours * 60
        const len = Math.floor((endMinutes - startMinutes) / stepMinutes)
        for (let i = 0; i <= len; i++) {
          const timeMinutes = startMinutes + i * stepMinutes
          const hours = Math.floor(timeMinutes / 60)
          const minutes = timeMinutes % 60
          const value = new Date(this.date).setHours(hours, minutes, 0)
          result.push({
            value,
            text: this.formatDate(value, fmt),
          })
        }
      }
      return result
    },
  },
  mounted() {
    this.scrollToSelected()
  },
  methods: {
    formatDate(date, fmt) {
      return format(date, fmt, getLocale(this.$i18n.locale))
    },
    scrollToSelected() {
      const element = this.$el.querySelector('.active')
      if (!element) { return }
      const scrollElement = getScrollParent(element, this.$el)
      if (!scrollElement) { return }
      const to = element.offsetTop
      scrollTo(scrollElement, to)
    },
    handleSelect(value) {
      this.$emit('select', value, 'time')
    },
  },
}
</script>